var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "256px",
    height: "256px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M59,10H5a3,3,0,0,0-3,3V51a3,3,0,0,0,3,3h6v2a1,1,0,0,0,1.447.9L16,55.118,19.553,56.9A1,1,0,0,0,21,56V54H59a3,3,0,0,0,3-3V13A3,3,0,0,0,59,10ZM16,48a8,8,0,1,1,8-8A8.009,8.009,0,0,1,16,48Zm3,6.382-2.553-1.277a1,1,0,0,0-.894,0L13,54.382V49.539a9.992,9.992,0,0,0,6,0ZM60,51a1,1,0,0,1-1,1H21V48.647a10,10,0,1,0-10,0V52H5a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1H59a1,1,0,0,1,1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M22,20H42a3,3,0,0,0,0-6H22a3,3,0,0,0,0,6Zm0-4H42a1,1,0,0,1,0,2H22a1,1,0,0,1,0-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M56,25a3,3,0,0,0-3-3H11a3,3,0,0,0,0,6H53A3,3,0,0,0,56,25ZM10,25a1,1,0,0,1,1-1H53a1,1,0,0,1,0,2H11A1,1,0,0,1,10,25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M55,30H31a3,3,0,0,0-3,3V47a3,3,0,0,0,3,3H55a3,3,0,0,0,3-3V33A3,3,0,0,0,55,30Zm1,17a1,1,0,0,1-1,1H31a1,1,0,0,1-1-1V33a1,1,0,0,1,1-1H55a1,1,0,0,1,1,1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M35.5,35A1.5,1.5,0,0,1,37,36.5a1,1,0,0,0,2,0,3.5,3.5,0,0,0-7,0v4a3.5,3.5,0,0,0,7,0,1,1,0,0,0-2,0,1.5,1.5,0,0,1-3,0v-4A1.5,1.5,0,0,1,35.5,35Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M43.5,33A3.5,3.5,0,0,0,40,36.5v4a3.5,3.5,0,0,0,7,0v-4A3.5,3.5,0,0,0,43.5,33ZM45,40.5a1.5,1.5,0,0,1-3,0v-4a1.5,1.5,0,0,1,3,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#73BC45",
    d: "M54.5,42a3,3,0,0,0-6,0,1,1,0,0,0,2,0,1,1,0,1,1,1.6.8l-3.2,2.4a1,1,0,0,0,.6,1.8h4a1,1,0,0,0,0-2h-1l.8-.6A3.015,3.015,0,0,0,54.5,42Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M16,34a6,6,0,0,0-5.5,3.6,1,1,0,1,0,1.832.8A4,4,0,0,1,16,36a1,1,0,0,0,0-2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4196fe",
    d: "M12.079,40.8a1,1,0,1,0-1.959.4A6.019,6.019,0,0,0,11.2,43.6a1,1,0,1,0,1.6-1.2A3.934,3.934,0,0,1,12.079,40.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.ea19238bb786feafae41b079a5fa45d9.svg";
export { ForwardRef as ReactComponent };